import {
  Account,
  Client as AppwriteClient,
  ID,
  Permission,
  Query,
  Role,
  TablesDB,
} from 'appwrite';
import {
  Account as ServerAccount,
  Client as ServerClient,
  Databases as ServerDatabases,
} from 'node-appwrite';

import { AppClient, AppTables } from '@polybank/shared';
import { appConfig } from '@/appConfig';
export {
  ID,
  Permission,
  Query,
  Role,
  ServerAccount,
  ServerClient,
  ServerDatabases,
};

// Appwrite client configuration - Support both naming conventions
export const APPWRITE_ENDPOINT = appConfig.APPWRITE_ENDPOINT;

export const APPWRITE_PROJECT_ID = appConfig.APPWRITE_PROJECT_ID;

// Re-export shared constants

/**
 * base client side sdk
 */
const appwriteClientSideClient = new AppwriteClient()
  .setEndpoint(APPWRITE_ENDPOINT!)
  .setProject(APPWRITE_PROJECT_ID!);

const appClientTables = new TablesDB(appwriteClientSideClient);
const appCustomTables = new AppTables<'client'>(
  appClientTables,
  appConfig.APPWRITE_DATABASE_ID!
);
const appClientAccount = new Account(appwriteClientSideClient);

export const appClient: AppClient = {
  client: appwriteClientSideClient,
  account: appClientAccount,
  tables: Object.assign(appClientTables, { typed: appCustomTables }),
};
